import {
  GET_DATA_PASANGAN,
  GET_DATA_ANAK,
  GET_DATA_KELUARGA
} from 'shared/constants/ActionTypes';

const INIT_STATE = {
  anak: [],
  keluarga: [],
  suamiIstri: [],
};

const keluargaReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_DATA_ANAK: {
      return {
        ...state,
        anak: action.payload
      }
    }
    case GET_DATA_PASANGAN: {
      return {
        ...state,
        suamiIstri: action.payload
      }
    }
    case GET_DATA_KELUARGA: {
      return {
        ...state,
        keluarga: action.payload
      }
    }
    default:
      return state;
  }
};
export default keluargaReducer;
